import { Badge } from "~/components/ui/badge";
import { cn } from "~/lib/utils";
import { AgentStatus } from "~/services/agents";

interface StatusBadgeProps {
  status: AgentStatus;
}

const labelByStatus: Record<StatusBadgeProps["status"], string> = {
  DISABLED: "Disabled",
  ENABLED: "Enabled",
  DELETED: "Deleted",
};

const styleByStatus: Record<StatusBadgeProps["status"], string> = {
  DISABLED: "border-gray-400 text-gray-500 dark:text-gray-400",
  ENABLED: "border-green-400 text-green-700 dark:text-green-400",
  DELETED: "border-red-400 text-red-700 dark:text-red-400",
};

export const StatusBadge = ({ status }: StatusBadgeProps) => (
  <Badge
    variant="outline"
    className={cn("rounded-full gap-1 bg-transparent", styleByStatus[status])}
  >
    <span className="size-1.5 shrink-0 rounded-full bg-current" />
    {labelByStatus[status]}
  </Badge>
);
